import { Resource } from "../resource/resource.model";

export class CorePreference extends Resource {
    name: string;
    type: string;
    label: string;
    businessUnit: string;
    translations: { [languageCode: string]: { label?: string; description?: string } };
    customCSS: string;
    html: string;
    isRequired: boolean;
    internalDescription: string;
    description: string;
    status: string;
    frequenciesIds: string[];
    channelsIds: string[];
    tenantId: string;
    internalID: string;
    preferenceCatalogId: string;
}
